@if (configuration$ | async; as configuration) {
  <div class="flex flex-1 items-center gap-4">
    @if (configuration.options) {
      <mat-form-field class="flex-1">
        <mat-label>{{ configuration.label }}</mat-label>
        <mat-select
          [multiple]="configuration.multiple"
          [formControl]="formCtrl"
        >
          @for (option of options; track option) {
            <mat-option [value]="option.value">
              {{ option.label }}
            </mat-option>
          }
        </mat-select>
        <ng-container *ngTemplateOutlet="helpIcon" />
      </mat-form-field>
    } @else {
      @if (configuration.type === metadataType.Boolean) {
        <mat-checkbox [formControl]="formCtrl">
          {{ configuration.label }}
        </mat-checkbox>
        <ng-container *ngTemplateOutlet="helpIcon" />
      } @else if (configuration.type === metadataType.Number) {
        <mat-form-field class="flex-1">
          <mat-label>{{ configuration.label }}</mat-label>
          <input matInput type="number" [formControl]="formCtrl" />
          <ng-container *ngTemplateOutlet="helpIcon" />
        </mat-form-field>
      } @else if (configuration.type === metadataType.String) {
        <mat-form-field class="flex-1">
          <mat-label>{{ configuration.label }}</mat-label>
          <input matInput type="text" [formControl]="formCtrl" />
          <ng-container *ngTemplateOutlet="helpIcon" />
        </mat-form-field>
      }
    }

    <ng-template #helpIcon>
      @if (configuration.description) {
        <mat-icon
          matIconSuffix
          class="icon-sm ml-2 opacity-50"
          [matTooltip]="configuration.description"
          >info</mat-icon
        >
      }
    </ng-template>
  </div>
}
